<style src="./Footer.scss" lang="scss"></style>

<template lang="pug">
  footer.footer
    .footer__copy {{ $l10n("COPYRIGHT") }}
    .footer__links
      Links(
        :links='links'
        :social='social'
      )
</template>

<script>
import Links from "@/components/Links/Links";
import Subscribe from "@/components/Subscribe/Subscribe";

import { mapGetters } from "vuex";
import { USER_GROUP_ARTIST } from "@/constants";

export default {
  data() {
    return {
      links: [],
      social: []
    };
  },
  components: {
    Links,
    Subscribe
  },
  computed: {
    ...mapGetters({
      userGroup: "user/group"
    }),
    isArtist() {
      return this.userGroup === USER_GROUP_ARTIST;
    }
  },
  created() {
    this.links = [
      { title: this.$l10n("RIGHTHOLDER"), url: "/pages/rightholder" },
      {
        title: this.$l10n("AGREEMENT"),
        url: this.isArtist ? "/pages/artist-agreement" : "/pages/agreement"
      },
      { title: this.$l10n("POLICY"), url: "/pages/help" }
    ];
    this.social = [
      { url: "//vk.com/iWorship", label: this.$l10n("VKONTAKTE"), icon: "vk" },
      {
        url: "//fb.com/mysong",
        label: this.$l10n("FACEBOOK"),
        icon: "facebook"
      },
      {
        url: "//instagram.com/www_song_ru",
        label: this.$l10n("INSTAGRAM"),
        icon: "instagram"
      }
    ];
  }
};
</script>
